export enum GameEvents {
  SELECT = 'select',
  DESELECT = 'deselect',
  REDUCE_STOCK = 'reduce stock',
  ADD_DISPLAY = 'add display',
  PURCHASE_INVENTORY = 'purchase inventory',
  GET_SHIPMENT = 'get shipment',
  BUILD_FRANKEN = 'build-franken',
  CASH_REGISTER = 'cash-register',
  MURDER = 'murder',
  RETRIEVE_PARTS = 'retrieve parts',
  CUSTOMER_ENTERS = 'customer enter',
  CUSTOMER_LEAVE = 'customer leave',
  FRANK_BUILT = 'frank built',
  LOSS = 'debt',
  WIN = 'win',
  CANT_BUILD_FRANK = 'cant build frank'
}
